import { FloraHelperText, FloraHelperTextProps } from '../'

/**
 * @deprecated Esta tipagem mudou para `FloraHelperTextProps`
 */
export type HelperTextProps = FloraHelperTextProps

/**
 * @deprecated Este componente mudou para `FloraHelperText`
 */
export const HelperText = FloraHelperText
